import { render, staticRenderFns } from "./StoreCardComponent.vue?vue&type=template&id=075b1961&scoped=true"
import script from "./StoreCardComponent.vue?vue&type=script&lang=js"
export * from "./StoreCardComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreCardComponent.vue?vue&type=style&index=0&id=075b1961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075b1961",
  null
  
)

export default component.exports